<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute">
      <v-row no-gutters align="center">
        <v-col cols="6" class="pt-8">
          <modal-cadu :close="close" :width="1131.52" v-model="show">
            <div slot="all" class="pt-10 pb-4 px-10">
              <div slot="header">
                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d">
                  {{ nomeAcao }} ÁREA
                </div>
              </div>

              <div slot="body" class="body-line">
                <v-row align="center" justify="start">
                  <v-col cols="12" md="6" class="pr-0 mr-2">
                    <validation-provider
                        name="area"
                        ref="area"
                        mode="eager"
                        rules="required|max:70"
                        v-slot="{ errors }"
                    >
                      <autocomplete-cadu
                          class="area-modal"
                          :errorMessage="errors[0]"
                          title="Área"
                          v-model="area"
                          :items="listaAreas"
                          :disabled="!canEdit || isEdit"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @index="(index) => selectArea(index)"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pr-0" cols="12" md="4">
                    <validation-provider
                        name="emailArea"
                        mode="eager"
                        ref="emailArea"
                        rules="required|email|max:100"
                        v-slot="{ errors }"
                    >
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="E-mail da Área"
                          v-model="emailArea"
                          emailMask
                          max="100"
                          :disabled="!canEdit"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :onlylowerCase="true"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pl-3 pt-8" cols="12" md="1" v-if="propAreas.emailArea">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <icon v-if="statusEmail === 2" name="check" :size="12" class="primary1--text" />

                          <span v-else-if="statusEmail === 1" class="warningUtil2--text" style="font-size: 14px"
                          >!</span
                          >

                          <icon v-else-if="statusEmail === 0" name="x" :size="12" class="error--text" />
                        </div>
                      </template>

                      <span>{{ tooltipTextArea() }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-row align="center">
                  <v-col cols="12" md="4" class="pr-0 mr-2">
                    <validation-provider name="responsavel" mode="eager" rules="required|max:100" v-slot="{ errors }">
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="Nome do Responsável"
                          onlyText
                          max="100"
                          v-model="responsavel"
                          :disabled="!canEdit"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pr-0" cols="12" md="5">
                    <validation-provider
                        name="emailResponsavel"
                        mode="eager"
                        rules="required|email|max:100"
                        v-slot="{ errors }"
                    >
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="E-mail do Responsável"
                          max="100"
                          emailMask
                          v-model="emailResponsavel"
                          :disabled="!canEdit"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :onlylowerCase="true"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pl-3 pt-8" cols="12" md="1" v-if="propAreas.emailResponsavel">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <icon v-if="statusEmailRes === 2" name="check" :size="12" class="primary1--text" />
                          <span v-else-if="statusEmailRes === 1" class="warningUtil2--text" style="font-size: 14px"
                          >!</span
                          >
                          <icon v-else-if="statusEmailRes === 0" name="x" :size="12" class="error--text" />
                        </div>
                      </template>

                      <span>{{ tooltipTextResponsavel() }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-row v-if="isEdit || (canEdit && !isEdit)">
                  <v-col cols="12" md="auto">
                    <div class="primary1--text">SEXO</div>
                    <v-row>
                      <v-col>
                        <checkbox-cadu v-model="checkF" :error="errorCheck" rounded>
                          <div slot="text">Feminino</div>
                        </checkbox-cadu>
                      </v-col>

                      <v-col cols="12" md="auto">
                        <checkbox-cadu v-model="checkM" :error="errorCheck" rounded>
                          <div slot="text">Masculino</div>
                        </checkbox-cadu>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-else>
                  <v-col cols="auto">
                    <div class="primary1--text">SEXO</div>

                    <checkbox-cadu v-model="checkEdit" rounded disable>
                      <div slot="text">{{ sexo.toLowerCase() === 'm' ? 'Masculino' : 'Feminino' }}</div>
                    </checkbox-cadu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <div class="primary1--text">TELEFONE</div>

                    <v-row>
                      <v-col cols="12" md="8">
                        <validation-provider
                            ref="numero"
                            name="numero"
                            mode="eager"
                            rules="required|telRequired"
                            v-slot="{ errors }"
                        >
                          <input-cadu
                              :errorMessage="errors[0]"
                              title="Número"
                              :value="telefone"
                              v-mask="telMask"
                              :disabled="!canEdit"
                              :colorText="$vuetify.theme.themes.light.fontColor1"
                              @input="telMuda"
                          />
                        </validation-provider>
                      </v-col>

                      <v-col cols="12" md="4">
                        <validation-provider name="ramal" mode="eager" rules="numeric|max:13" v-slot="{ errors }">
                          <input-cadu
                              :errorMessage="errors[0]"
                              title="Ramal"
                              v-model="ramal"
                              onlyNumber
                              :max="'5'"
                              :disabled="!canEdit"
                              :colorText="$vuetify.theme.themes.light.fontColor1"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <div>
                  <div class="primary1--text">COLABORADORES DA ÁREA</div>

                  <v-row no-gutters align="center" justify="center">
                    <v-col>
                      <TabelaModalArea
                          :nomeAcao="nomeAcao"
                          :edit="canEdit && isEdit"
                          :isNew="isNew || (canEdit && isEdit)"
                          :showCheckModalArea="opcaoEditar && isEdit"
                          :colaboradores="areaColaboradores"
                          :pagina="paginaCola"
                          :qtPaginas="qtPaginasCola"
                          :qtResultados="qtResultadosCola"
                          :items="['05', '10', '15']"
                          :role="role"
                          :elementos="elementsPerPageCola"
                          :ordemProp="ordemCola"
                          v-if="!isLoadingOverlay"
                          @change-element="(elemento) => changeElementCola(elemento)"
                          @change-page="(currentPage) => changePageCola(currentPage.currentPage)"
                          @clickButton="(obj) => clickButton(obj)"
                          @ordena="(ordem) => ordenaCola(ordem)"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div slot="footer" class="pt-6">
                <div v-if="!$vuetify.breakpoint.xs">
                  <div v-if="!isEdit && !canEdit">
                    <v-row align="end" justify="end">
                      <v-col cols="auto">
                        <button-cadu @click="show = false">VOLTAR</button-cadu>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else>
                    <v-row align="start" justify="start">
                      <v-col cols="auto" v-if="isEdit">
                        <button-cadu outline @click="verifyCancelar">CANCELAR</button-cadu>
                      </v-col>

                      <v-col cols="auto" v-if="isNew">
                        <button-cadu outline @click="show = false">VOLTAR</button-cadu>
                      </v-col>

                      <v-row align="end" justify="end" class="mr-2">
                        <v-col cols="auto" v-if="isEdit && canEdit">
                          <button-cadu
                              :backColor="$vuetify.theme.themes.light.primary2"
                              block
                              class="px-4"
                              @click="reenviarEmail()"
                          >REENVIAR E-MAILS NÃO CONFIRMADOS</button-cadu
                          >
                        </v-col>

                        <v-col cols="auto" v-if="isNew">
                          <button-cadu
                              text="SALVAR E ADICIONAR OUTRO"
                              block
                              class="px-4"
                              :backColor="$vuetify.theme.themes.light.primary2"
                              @click="saveArea(true)"
                          />
                        </v-col>

                        <v-col @click="saveArea(false)" cols="auto">
                          <button-cadu>SALVAR</button-cadu>
                        </v-col>
                      </v-row>
                    </v-row>
                  </div>
                </div>

                <div v-else>
                  <v-row>
                    <v-row>
                      <v-col cols="12" v-if="isEdit && canEdit">
                        <button-cadu :backColor="$vuetify.theme.themes.light.primary2" block @click="reenviarEmail()">
                          REENVIAR E-MAILS NÃO CONFIRMADOS
                        </button-cadu>
                      </v-col>

                      <v-col cols="12" v-if="isNew">
                        <button-cadu
                            text="SALVAR E ADICIONAR OUTRO"
                            block
                            :backColor="$vuetify.theme.themes.light.primary2"
                            @click="saveArea(true)"
                        />
                      </v-col>

                      <v-col @click="saveArea(false)" cols="12">
                        <button-cadu block>SALVAR</button-cadu>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" v-if="isEdit">
                        <button-cadu outline block @click="verifyCancelar">CANCELAR</button-cadu>
                      </v-col>

                      <v-col cols="12" v-if="isNew">
                        <button-cadu outline block @click="show = false">VOLTAR</button-cadu>
                      </v-col>
                    </v-row>
                  </v-row>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>

    <ModalColaborador
        :value="showColaborador"
        :dominiosAreas="dominiosAreas"
        :listaAreas="listaAreas"
        :nomeAcao="acaoColaborador"
        :nomeAcaoArea="nomeAcao"
        :email="emailArea"
        :isNew="isNewCola"
        :isEdit="isEditCola"
        :area="area"
        :colaborador="colaborador"
        :idArea="propAreas.id"
        :idTipoAreaProp="propAreas.tipoArea ? propAreas.tipoArea.id : null"
        :emailCheck="statusEmail"
        ref="colaborador"
        @save="(obj) => saveColaborador(obj, true)"
        @new-save="(obj) => saveColaborador(obj, false)"
        @edit-colaborador="(obj) => editColaborador(obj)"
        @input="fecharColaborador"
    />

    <ExcluirModal
        :showDelete="showDelete"
        text="Tem certeza que deseja excluir esse colaborador?"
        @close="fecharExcluir"
        @confirmDelete="confirm()"
    />

    <SucessoModal
        :showSucess="showSucess"
        :sucessType="type"
        :genericMessage="genericMessage"
        successName="Colaborador"
        @close="fecharSucesso"
    />

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="resetEdicao" />

    <error-modal v-model="error" :errObj="errObj" @input="fecharError()" />

    <overlay-loading :value="isLoadingOverlay" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import jwtDecode from 'jwt-decode'
import { mask } from 'vue-the-mask'

import Areas from '@/services/Areas/Areas'
import Colaboradores from '@/services/Areas/Colaboradores'
import TabelaModalArea from './TabelaModalArea'
import ModalColaborador from '../Colaborador/ModalColaborador'
import { cloneDeep, isEqual } from 'lodash'
import ErrorMixin from '@/Mixins/ErrorMixin'
import router from '@/router'

export default {
  mixins: [ErrorMixin],
  directives: { mask },
  components: {
    ValidationProvider,
    ValidationObserver,
    TabelaModalArea,
    ModalColaborador
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: true
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false
    },
    nomeAcao: {
      type: String,
      required: false,
      default: '',
      note: 'essa prop funciona com VISUALIZAR | ADICIONAR | EDITAR'
    },
    propAreas: {
      type: Object,
      required: false
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      close: true,
      show: this.value,
      checkM: false,
      checkF: false,
      checkEdit: true,

      acao: this.nomeAcao,
      listaAreas: [],
      dominiosAreas: [],
      area: '',
      emailArea: '',
      responsavel: '',
      sexo: '',
      emailResponsavel: '',
      telefone: '',
      ramal: '',
      areaColaboradores: [],
      selectedArea: {},

      role: '',
      showColaborador: false,
      nameColaborador: '',
      telMask: '(##) #####-####',
      acaoColaborador: '',
      isLoadingOverlay: false,
      qtResultadosCola: 0,
      qtPaginasCola: 0,
      paginaCola: 1,
      ordemCola: 'desc',
      campoOrdenado:'',
      isNewCola: false,
      isEditCola: false,
      idArea: this.propAreas.id,
      colaborador: {},
      elementsPerPageCola: 5,
      delSelected: [],
      showDelete: false,
      showSucess: false,
      type: '',
      emailCheck: -1,
      errorCheck: false,
      genericMessage: '',

      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      error: false,
      errObj: {
        status: '',
        error: ''
      },
      showModalCancelar: false,
      cloneAreas: {},
      statusEmail: -1,
      statusEmailRes: -1
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    const decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
  },
  methods: {
    async fecharExcluir() {
      this.showDelete = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    fecharColaborador(input) {
      this.showColaborador = input

      if (!this.showColaborador) this.$nextTick(() => (this.show = true))
    },
    async fecharSucesso() {
      this.showSucess = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
      this.show = true
    },
    fecharError() {
      if (this.errObj.status === 422) router.push('/home')
    },
    tooltipTextArea() {
      switch (this.statusEmail) {
        case 0:
          return 'Não Confirmado'
        case 1:
          return 'Pendente'
        case 2:
          return 'Confirmado'
      }
    },
    tooltipTextResponsavel() {
      switch (this.statusEmailRes) {
        case 0:
          return 'Não Confirmado'
        case 1:
          return 'Pendente'
        case 2:
          return 'Confirmado'
      }
    },
    async verifyCancelar() {
      const newObj = {
        id: this.cloneAreas.id,
        tipoArea: { nome: this.area, id: this.selectedArea },
        emailArea: { endereco: this.emailArea },
        nomeResponsavel: this.responsavel,
        emailResponsavel: { endereco: this.emailResponsavel },
        sexoResponsavel: this.sexo,
        telefone: this.telefone.replace(/[^0-9.]/g, ''),
        ramal: this.ramal ? this.ramal.replace(/[^0-9.]/g, '') : null,
        colaboradores: null,
        statusEmail: this.statusEmail
      }

      if (!isEqual(this.cloneAreas, newObj)) this.showModalCancelar = true
    },
    async resetEdicao() {
      this.showModalCancelar = false

      this.isLoadingOverlay = true

      await this.getDominioAreas(true)
      await this.getColaborador()

      this.area = this.cloneAreas.tipoArea.nome
      this.selectedArea = this.cloneAreas.tipoArea.id
      this.emailArea = this.cloneAreas.emailArea.endereco
      this.responsavel = this.cloneAreas.nomeResponsavel
      this.emailResponsavel = this.cloneAreas.emailResponsavel.endereco
      this.sexo = this.cloneAreas.sexoResponsavel

      if (this.sexo.toLowerCase() === 'm') this.checkM = true
      else this.checkF = true

      this.telefone = this.cloneAreas.telefone
      this.ramal = this.cloneAreas.ramal

      await this.$refs.numero.reset()

      this.isLoadingOverlay = false
    },
    async start(propAreas) {
      this.isLoadingOverlay = true
      this.cloneAreas = {}
      this.dominiosAreas = []
      this.listaAreas = []
      this.paginaCola = 1

      if (!propAreas) {
        await this.decidePut()
        await this.getDominioAreas(false)
        await this.getColaborador()

        this.clean()
      } else {
        this.getArea(propAreas)
        this.cloneAreas = cloneDeep(propAreas)
        this.cloneAreas.statusEmail = this.cloneAreas.emailArea.statusEmail
        this.cloneAreas.emailArea = { endereco: propAreas.emailArea.endereco }
        this.cloneAreas.emailResponsavel = { endereco: propAreas.emailResponsavel.endereco }
        this.cloneAreas.tipoArea = { id: propAreas.tipoArea.id, nome: propAreas.tipoArea.nome }

        this.emailCheck = propAreas.emailArea.statusEmail

        await this.decidePut()
        await this.getDominioAreas(true)
        await this.getColaborador()
      }
      this.isLoadingOverlay = false
      this.$nextTick(() => {
        this.$emit('input', true)
      })
    },
    async decidePut() {
      if (this.nomeAcao === 'VISUALIZAR') return

      const area = new Areas(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      const nomeFunc = this.nomeAcao === 'ADICIONAR' ? 'putAdicionar' : 'putEditar'
      const valor = this.nomeAcao === 'EDITAR' ? this.cloneAreas.id : ''

      await this.promiseGeneric(area, nomeFunc, valor)
    },
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.isLoadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async reenviarEmail() {
      if (await this.$refs.observer.validate()) {
        let areas = new Areas(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
        this.isLoadingOverlay = true
        try {
          await areas.reenviarEmail(this.idArea)
          this.isLoadingOverlay = false
          await this.$nextTick()
          this.showSucess = true
          this.type = 'generic'
          this.genericMessage = 'E-mails enviados com sucesso!'
        } catch (err) {
          this.isLoadingOverlay = false
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          console.error(err)
        }
      }
    },
    async confirm() {
      this.showDelete = false
      this.isLoadingOverlay = true
      await this.delColaborador(this.delSelected)
      await this.getColaborador()
      this.paginaCola = 1
      this.isLoadingOverlay = false
      this.showSucess = true
    },
    async ordenaCola(ordem) {
      this.setCampoOrdenado(ordem.index)
      this.ordemCola = ordem.ordem
      this.isLoadingOverlay = true
      await this.getColaborador()
      this.isLoadingOverlay = false
    },
    setCampoOrdenado(index) {
      switch (index) {
        case 0:
          this.campoOrdenado = 'nome'
          break
        case 1:
          this.campoOrdenado = 'cargo.nome'
          break
        case 2:
          this.campoOrdenado = 'email.endereco'
          break
        default:
          this.campoOrdenado = ''
          break
      }
    },
    async changeElementCola(element) {
      this.elementsPerPageCola = element
      this.paginaCola = 1
      this.isLoadingOverlay = true
      await this.getColaborador()
      this.isLoadingOverlay = false
    },
    async changePageCola(page) {
      this.paginaCola = page
      this.isLoadingOverlay = true
      await this.getColaborador()
      this.isLoadingOverlay = false
    },
    telMuda(value) {
      this.telefone = value
      if (this.telefone) {
        if (
            this.telefone.startsWith('(08) 00') ||
            this.telefone.startsWith('(03) 00') ||
            this.telefone.startsWith('0800') ||
            this.telefone.startsWith('0300')
        ) {
          this.telMask = '#### ### ####'
        } else if (this.telefone.length > 14) {
          this.telMask = '(##) #####-####'
        } else if (this.telefone.length <= 14) {
          this.telMask = '(##) ####-#####'
        }
      }
    },
    async editColaborador(obj) {
      let areas = new Areas(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      this.isLoadingOverlay = true

      try {
        await areas.putAreas(obj)

        await this.getColaborador()
        this.isLoadingOverlay = false
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.isLoadingOverlay = false
      }
    },
    async saveColaborador(res, bool) {
      this.showColaborador = false
      this.isLoadingOverlay = true

      const data = res.obj
      let idAreaDestino = res.idArea === null ? this.idArea : res.idArea

      if (this.nomeAcao === 'ADICIONAR') {
        idAreaDestino = ''
        this.idArea = ''
      }

      const colaborador = new Colaboradores(
          localStorage.getItem('tokenBearer'),
          this.$appConfig.config.API,
          this.$idUnimed,
          this.idArea
      )

      await colaborador
          .putColaboradores(data, idAreaDestino)
          .then((res) => {
            this.idArea = res.data

            this.$emit('change-id', this.idArea)

            this.getColaborador()

            this.showSucess = true
            if (!bool) {
              this.openColaborador()
            }
          })
          .catch((err) => {
            console.error(err)
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
          })
          .finally(() => (this.isLoadingOverlay = false))
    },
    async clickButton(obj) {
      let type = obj.type
      switch (type) {
        case 'view':
          this.acaoColaborador = 'VISUALIZAR'
          this.isEditCola = false
          this.isNewCola = false
          this.isLoadingOverlay = true
          await this.getColaborador(true, obj.index)
          this.isLoadingOverlay = false
          this.openColaborador()
          break
        case 'edit':
          this.acaoColaborador = 'EDITAR'
          this.isNewCola = false
          this.isEditCola = true
          this.type = 'edit'
          this.isLoadingOverlay = true
          await this.getColaborador(true, obj.index)
          this.isLoadingOverlay = false
          this.openColaborador()
          break
        case 'delAll':
          this.type = 'del'
          this.delSelected = obj.selected
          this.$emit('input', false)
          this.showDelete = true
          break
        case 'delete':
          this.type = 'del'
          this.delSelected = [this.areaColaboradores[obj.index].id]
          this.showDelete = true
          break
        case 'add':
          await this.adicionarColaborador();
          break
        default:
          break
      }
    },
    async adicionarColaborador() {
      let area = await this.$refs.area.validate()
      let email = await this.$refs.emailArea.validate()
      if (area.valid && email.valid) {
        this.acaoColaborador = 'ADICIONAR'
        this.isNewCola = true
        this.isEditCola = false
        this.type = 'new'
        this.openColaborador()
      }
    },
    async getColaborador(isSingleItem, index) {
      const colaboradores = new Colaboradores(
          localStorage.getItem('tokenBearer'),
          this.$appConfig.config.API,
          this.$idUnimed,
          this.idArea
      )

      const nomeFunc = this.nomeAcao === 'VISUALIZAR' ? 'getColaboradores' : 'getColaboradoresEdicao'

      await colaboradores[nomeFunc](this.args)
          .then((res) => {
            res = res.data

            this.areaColaboradores = res.conteudo
            this.qtResultadosCola = res.qtResultados
            this.qtPaginasCola = res.qtPaginas
            this.paginaCola = res.pagina
            this.colaborador = this.areaColaboradores[index]
          })
          .catch((err) => {
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
            console.error(err)
          })
    },
    async delColaborador(data) {
      const colaboradores = new Colaboradores(
          localStorage.getItem('tokenBearer'),
          this.$appConfig.config.API,
          this.$idUnimed,
          this.idArea
      )

      await colaboradores
          .deleteColaboradores(data, this.idArea)
          .then((res) => {
            this.idArea = res.data
            this.$emit('change-id', this.idArea)
          })
          .catch((err) => {
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
            console.error(err)
          })
    },
    async getDominioAreas(bool) {
      let dominioAreas = new Areas(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseDominioAreas
        if (bool) {
          responseDominioAreas = await dominioAreas.getItens()
          responseDominioAreas.data.forEach((item) => {
            this.listaAreas.push(item.tipoArea.nome)
            this.dominiosAreas.push(item)
          })
        } else {
          responseDominioAreas = await dominioAreas.getTipoArea()
          responseDominioAreas.data.forEach((item) => {
            this.listaAreas.push(item.nome)
            this.dominiosAreas.push(item)
          })
        }
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
        // this.$router.push('/erro')
      }
    },
    clean() {
      this.area = ''
      this.emailArea = ''
      this.responsavel = ''
      this.emailResponsavel = ''
      this.sexo = ''
      this.checkM = false
      this.checkF = false
      this.telefone = ''
      this.ramal = ''
    },
    async getArea(propAreas) {
      this.area = propAreas.tipoArea.nome
      this.emailArea = propAreas.emailArea.endereco
      this.responsavel = propAreas.nomeResponsavel
      this.emailResponsavel = propAreas.emailResponsavel.endereco
      this.statusEmail = propAreas.emailArea.statusEmail
      this.statusEmailRes = propAreas.emailResponsavel.statusEmail
      if (propAreas.sexoResponsavel === 'M') {
        this.sexo = 'M'
        this.checkM = true
        this.checkF = false
      } else {
        this.sexo = 'F'
        this.checkM = false
        this.checkF = true
      }
      this.telefone = propAreas.telefone
      this.ramal = propAreas.ramal
    },
    selectArea(index) {
      if (this.nomeAcao === 'ADICIONAR') {
        this.selectedArea =
            index !== null && index > -1
                ? this.dominiosAreas[index].id
                : this.propAreas.tipoArea
                    ? this.propAreas.tipoArea.id
                    : null
      } else {
        this.selectedArea =
            index !== null && index > -1
                ? this.dominiosAreas[index].tipoArea.id
                : this.propAreas.tipoArea
                    ? this.propAreas.tipoArea.id
                    : null
      }
    },
    async saveArea(bool) {
      if (!(this.checkM || this.checkF)) {
        this.errorCheck = true
      }
      if ((await this.$refs.observer.validate()) && !this.errorCheck) {
        let obj = {
          colaboradores: this.areaColaboradores,
          emailArea: {
            id: null,
            endereco: this.emailArea,
            validado: false
          },
          emailResponsavel: {
            id: null,
            endereco: this.emailResponsavel,
            validado: false
          },
          id: this.propAreas ? this.propAreas.id : null,
          nomeResponsavel: this.responsavel,
          sexoResponsavel: this.sexo,
          telefone: this.telefone,
          ramal: this.ramal,
          tipoArea: {
            id: this.selectedArea
          }
        }
        this.$emit('input', true)
        this.$emit(bool ? 'new-save' : 'save-area', obj)
      }
    },
    async openColaborador() {
      this.show = false
      this.showColaborador = true
      await this.$refs.colaborador.start(this.colaborador)
    }
  },
  computed: {
    args() {
      return `?tamanhoPagina=${this.elementsPerPageCola}&pagina=${this.paginaCola}&areaId=${this.idArea}&direcaoOrdenacao=${this.ordemCola}&ordenacao=${this.campoOrdenado}`
    }
  },
  watch: {
    error() {
      if (this.error) {
        this.isLoadingOverlay = false
      }
    },
    propAreas() {
      this.idArea = this.propAreas.id
    },
    show() {
      if (!this.show) {
        this.errorCheck = false
        this.$emit('input', false)
      }
    },
    value() {
      this.show = this.value
    },
    checkM() {
      if (this.checkM) {
        this.checkF = false
        this.errorCheck = false
        this.sexo = 'M'
      }
    },
    checkF() {
      if (this.checkF) {
        this.checkM = false
        this.errorCheck = false
        this.sexo = 'F'
      }
    },
    nomeAcao() {
      this.acao = this.nomeAcao
    }
  }
}
</script>

<style>
.body-line {
  padding-bottom: 15px;
  border-bottom: 1px solid #9e9e9e80;
}

.area-modal > .IZ-select__menu {
  position: absolute !important;
}
</style>